import { render, staticRenderFns } from "./CustomRatingTableWithFilter.vue?vue&type=template&id=86fce27a&"
import script from "./CustomRatingTableWithFilter.vue?vue&type=script&lang=js&"
export * from "./CustomRatingTableWithFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports